import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

const JumbotronLandingBanner = ({
  jumbotronType,
  backgroundBigText,
  jumbotronContainerClassName,
  jumbotronEntityInfoClassName,
  headingEl,
  breadcrumbs,
  featuredImg,
  cityDescAttribute,
}) => {
  return (
    <div className={cs(jumbotronContainerClassName, jumbotronType)}>
      {/* Entity Featured Image */}
      {featuredImg}
      {backgroundBigText}
      <div className={cs('JumbotronBanner__wrapper', jumbotronType)}>
        {/* Header Entity Info Section */}
        <div className={`${jumbotronEntityInfoClassName}__container`}>
          <div className={jumbotronEntityInfoClassName}>
            {breadcrumbs}
            {headingEl}
            <div className="JumbotronBanner__entityDescription">
              <span>{cityDescAttribute}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

JumbotronLandingBanner.propTypes = {
  jumbotronType: PropTypes.string.isRequired,
  backgroundBigText: PropTypes.object,
  jumbotronContainerClassName: PropTypes.string.isRequired,
  headingEl: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.object,
  jumbotronEntityInfoClassName: PropTypes.string.isRequired,
  featuredImg: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  cityDescAttribute: PropTypes.string,
};

export default JumbotronLandingBanner;
